import {Breakpoints, styled} from '@vw-marketing/us-components';
import {styledSlick} from '../../components/slick/styled';

export const StyledSimilarVehiclesSlider = styled.div`
  margin-top: 20px;
`;

export const StyledSlickContainer = styled(styledSlick)`
  .slick-track {
    margin-left: 0;
  }

  .slick-arrow {
    cursor: pointer;
    width: fit-content;
    margin-bottom: 15px;

    > span {
      align-items: center;
      color: #001e50;
      display: flex;
      gap: 12px;
    }
  }

  .slick-next {
    position: absolute;
    right: 0;
    top: 0;

    .arrow-container-right {
      flex-wrap: nowrap;
      flex-direction: row-reverse;
    }
  }

  .slick-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    overflow: visible;

    .slick-arrow {
      margin-bottom: 40px;
    }

    .slick-list {
      margin: 0 -15px;
      overflow: visible;
    }

    .slick-slide > div {
      padding: 0 15px;
    }
  }
`;
